import { FunctionalComponent, h } from 'preact'
import { CSSProperties } from 'preact/compat'

type Props = {
  path: string
  viewBox: string
  width?: number
  height?: number
  stroke?: string
  className?: string
  style?: CSSProperties
  onClick?: () => void
}

const Svg: FunctionalComponent<Props> = (props) => {
  const { width = '100%', height = '100%', path, viewBox, className = '', stroke = '', onClick, style } = props

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={style}
    >
      <path d={path} fill="currentColor" stroke={stroke} />
    </svg>
  )
}

export default Svg
